import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { FLOW_SOURCES, sourceWaveStyle } from "../ConceptFlow.logic";
import styles from "../ConceptFlow.module.css";

export default function ConceptFlowSources() {
  const T = useT();

  return (
    <ul
      className={`${styles.sources} ${styles.anchorRight}`}
      aria-label={T(TKey.HOME_MEIDLY_FLOW_SOURCES_LABEL)}
    >
      {FLOW_SOURCES.map((source, index) => (
        <li
          className={styles.sourceTile}
          style={sourceWaveStyle(index)}
          key={source.labelKey}
          title={T(source.labelKey)}
        >
          <span className={styles.sourceIcon} aria-hidden="true">
            {source.Icon ? <source.Icon /> : source.text}
          </span>
          <span className={styles.srOnly}>{T(source.labelKey)}</span>
        </li>
      ))}
    </ul>
  );
}
